import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  ShopifyRatingOne,
  ShopifyRatingTwo,
  ShopifyRatingThree,
  ShopifyRatingFour,
  ShopifyRatingFive,
} from "../../../app-constants-updated";
import "../style/services-usa/shopify-web-development/_ratingfive.scss";

function RatingFive() {
  return (
    <section className="rating-five text_white p-100 overflow-x-hidden">
      <Container>
        <div className="rating-five-grid">
          <div className="rating">
            <div className="icon">{ShopifyRatingOne}</div>
            <div className="content">
              <h4>200+</h4>
              <p>Shopify websites Developed</p>
            </div>
          </div>
          <div className="rating">
            <div className="icon">{ShopifyRatingTwo}</div>
            <div className="content">
              <h4>40+</h4>
              <p>Shopify Developers</p>
            </div>
          </div>
          <div className="rating">
            <div className="icon">{ShopifyRatingThree}</div>
            <div className="content">
              <h4>150+</h4>
              <p>Custom eCommerce integrations</p>
            </div>
          </div>
          <div className="rating">
            <div className="icon">{ShopifyRatingFour}</div>
            <div className="content">
              <h4>85%</h4>
              <p>Faster Time-to-Market</p>
            </div>
          </div>
          <div className="rating">
            <div className="icon">{ShopifyRatingFive}</div>
            <div className="content">
              <h4>99%</h4>
              <p>Customer Satisfaction</p>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default RatingFive;
